import { paths } from '@/utils/path'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'vnetwork-ui'
import { tabs } from './tab'
import useTabs from '@/hooks/useTabs'
import SubHeaders from '@/components/Headers/SubHeaders'

const List = () => {
    const { t } = useTranslation()
    const { TabComponent, TabProps } = useTabs({ tabs: tabs(t) })

    return (
        <div>
            <SubHeaders
                actions={[]}
                breadcrumbs={[
                    {
                        path: paths.services,
                        title: t('service-list'),
                    },
                ]}
            />
            <Tabs {...TabProps} />
            <div className="mt-2"></div>
            {TabComponent}
        </div>
    )
}

export default List
